// extracted by mini-css-extract-plugin
export default {"container":"BillingCollectedFeeProgressBar_container__DgzPN","label":"BillingCollectedFeeProgressBar_label__wJv4-","value":"BillingCollectedFeeProgressBar_value__JsnlU"};